var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "klient-item first-analysis-client",
    "class": {
      'custom-client': !_vm.isFirstAnalysisClient,
      'admin-client-item': _vm.role === 'alex_admin'
    }
  }, [_c('div', {
    staticClass: "klient-item-to-part"
  }, [_c('div', {
    staticClass: "first-analysis-identity"
  }, [_c('div', {
    staticClass: "client-badges"
  }, [_vm.parsedSource.href || _vm.parsedSource.className === 'source-ads' ? _c('a', {
    staticClass: "source-badge",
    "class": _vm.parsedSource.className,
    attrs: {
      "href": _vm.parsedSource.href,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" " + _vm._s(_vm.parsedSource.label) + " ")]) : _vm._e(), _c('client-district-badges', {
    attrs: {
      "client": _vm.clientData
    }
  })], 1), _c('div', {
    staticClass: "first-analysis-identity-row"
  }, [_vm.role === 'alex_admin' ? _c('div', {
    staticClass: "assigned-broker"
  }, [_c('span', {
    staticClass: "identity-kicker"
  }, [_vm._v("Finančník")]), _c('div', {
    staticClass: "assigned-broker-avatar"
  }, [_c('broker-picker-handler', {
    attrs: {
      "rules": ['priority'],
      "broker-id": _vm.clientData.financnik,
      "client-info": _vm.clientData,
      "clients": "",
      "klient": ""
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "client-copy"
  }, [_vm.role === 'alex_admin' ? _c('span', {
    staticClass: "identity-kicker"
  }, [_vm._v("Klient")]) : _vm._e(), _c('user-manager-handler', {
    attrs: {
      "rules": ['priority'],
      "client-info": _vm.clientData,
      "client": "",
      "clients": "",
      "telephone": ""
    }
  })], 1)])]), _vm.isFirstAnalysisClient ? _c('div', {
    staticClass: "first-analysis-progress",
    attrs: {
      "aria-label": "Postup v Prvej analýze"
    }
  }, [_c('div', {
    staticClass: "first-analysis-progress-copy"
  }, [_c('span', [_vm._v("Prvá analýza")]), _c('strong', [_vm._v(_vm._s(_vm.currentProgressLabel))])]), _c('div', {
    staticClass: "first-analysis-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l(4, function (n) {
    return _c('span', {
      key: n,
      "class": {
        'is-complete': n <= _vm.checkPoints
      }
    });
  }), 0), _c('div', {
    staticClass: "first-analysis-step"
  }, [_vm._v(_vm._s(_vm.checkPoints) + "/4 krokov")])]) : _c('div', {
    staticClass: "custom-client-status"
  }, [_c('span', [_vm._v("Typ klienta")]), _c('strong', [_vm._v("Založený brokerom")]), _c('small', [_vm._v("Bez online prvej analýzy")])]), _c('div', {
    staticClass: "first-analysis-actions",
    "class": {
      'custom-client-actions': !_vm.isFirstAnalysisClient
    }
  }, [!_vm.isFirstAnalysisClient ? _c('div', {
    staticClass: "custom-client-action-copy"
  }, [_c('span', [_vm._v("Dostupné akcie")]), _c('strong', [_vm._v("Správa klienta")])]) : _vm._e(), _c('div', {
    staticClass: "custom-client-action-buttons"
  }, [_c('div', {
    staticClass: "first-analysis-action"
  }, [_c('client-chat-handler', {
    attrs: {
      "client": _vm.clientData,
      "rules": ['single']
    }
  })], 1), _c('div', {
    staticClass: "first-analysis-action"
  }, [_c('mortgage-picker-handler', {
    attrs: {
      "client": _vm.clientData,
      "rules": ['single']
    }
  })], 1)])])]), _vm.clientData.sent_latest_message ? _c('div', {
    staticClass: "lastmessage",
    on: {
      "click": _vm.openClientChatPopUp
    }
  }, [_vm.clientData.sent_unread_messages ? _c('div', {
    staticClass: "badge"
  }, [_c('div', {
    staticClass: "text-block-13"
  }, [_vm._v(" " + _vm._s(_vm.clientData.sent_unread_messages) + " ")])]) : _vm._e(), _c('div', [_vm._v(" " + _vm._s(_vm.clientData.sent_latest_message) + " ")])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }